// Care Management System — por ahora solo el submódulo patient-profiles.
import { lazy } from "react";

const PatientProfilesPage = lazy(() =>
  import("./patient-profiles/pages/PatientProfilesPage")
);

export const careManagementSystemRoutes = [
  { path: "/patient-profiles", element: <PatientProfilesPage /> },
];

export { PatientProfilesPage };
